import { MonitoringTopicsPage } from '@features/monitoringOffer';

export const MonitoringTopics = () => {
	return (
		<div className="w-full h-full max-w-[1440px] mx-auto px-5">
			<MonitoringTopicsPage />
		</div>
	);
};
